/**
 * Whether a photo can be opened in the advanced editor.
 *
 * A photo whose thumbnail failed to load has nothing for the editor to show, so Edit is
 * closed off for the rest of the session, in the desktop list view and the mobile grid
 * alike. Both views call this rather than testing the flag themselves, because they gate
 * Edit differently otherwise and had already drifted apart on it.
 *
 * `thumbnailFailed` is deliberately not persisted, so after a reload Edit is available
 * again and the editor retries the thumbnail. If it is still unreachable the editor has its
 * own load timeout and warning, so that degrades rather than breaks.
 *
 * @param {object} photo
 * @returns {boolean}
 */
const canOpenAdvancedEditor = (photo) => !photo || !photo.thumbnailFailed;

export default canOpenAdvancedEditor;
